export default function ActionPlansPage() {
  return <div style={{ padding: 24 }}><h2>Action Plans — Coming Sprint 2</h2></div>
}
